import React, { useCallback } from 'react';
import { colors } from 'spw-theme';
import styled from 'styled-components';
import GreenCheckLgIcon from 'spw-static/images/green-check-lg.svg';
import RedWarningLgIcon from 'spw-static/images/red-warning-lg.svg';
import DeleteIcon from 'spw-static/images/delete-input-icon.svg';
import { Box, IconButton } from '@mui/material';
import Img from 'react-cool-img';
import { useDispatch, useSelector } from 'react-redux';
import { selectToastMessage } from 'spw-redux/modules/UI/messages/selectors';
import { ToastMessage as ToastMessageType } from 'spw-redux/modules/UI/messages/types';
import { hideToastMessage } from 'spw-redux/modules/UI/messages/actions';

const Container = styled.div`
  align-items: center;
  background: ${colors.white};
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  box-sizing: border-box;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  display: flex;
  font-size: 16px;
  font-weight: 500;
  height: 66px;
  justify-content: space-between;
  line-height: 20px;
  min-width: 231px;
  padding: 0 16px;
  position: fixed;
  right: 100px;
  top: 52px;
  width: max-content;
  z-index: 1301;

  .status-icon {
    width: 24px;
    height: 24px;
    margin-right: 16px;
  }

  .close-icon {
    width: 18px;
    height: 18px;
  }
`;

const statusColorMap = {
  success: colors.mainGreen,
  error: colors.red,
} as Record<ToastMessageType['status'], string>;

const statusSrcMap = {
  success: GreenCheckLgIcon,
  error: RedWarningLgIcon,
} as Record<ToastMessageType['status'], string>;

const ToastMessage = () => {
  const dispatch = useDispatch();
  const { status, text } = useSelector(selectToastMessage);

  const handleDeleteIconClick = useCallback(() => {
    dispatch(hideToastMessage());
  }, [dispatch]);

  if (!status) return null;

  const borderColor = statusColorMap[status];
  const imgSrc = statusSrcMap[status];

  return (
    <Container style={{ borderColor }} data-testid={`${status}-message`}>
      <Img className="status-icon" src={imgSrc} />
      {text}
      <Box marginLeft="16px">
        <IconButton onClick={handleDeleteIconClick} size="large">
          <Img className="close-icon" src={DeleteIcon} />
        </IconButton>
      </Box>
    </Container>
  );
};

export default ToastMessage;
